import { OpinionQuestionOptionLabel } from 'api/dto/new/Common/OpinionQuestionOptionLabel.dto';
import { components } from 'type/ReportServiceSchema';

export type FeedbackDto = components['schemas']['Feedback2'];

export type FeedbackModel = {
  label: OpinionQuestionOptionLabel;
  options: string[];
  type: number;
  value: number;
};

export const mapFeedbackDtoToModel = (dto: FeedbackDto): FeedbackModel => ({
  value: dto.value,
  label: dto.label as OpinionQuestionOptionLabel,
  options: dto.options as string[],
  type: dto.type,
});
